@import "../../theme/global";

.camera {
  max-height: 320px !important;
  overflow: hidden;
  background-color: $background-color-step-150;
  lar-icon {
    position: absolute;
    margin: 150px auto 0 auto;
    left: 50%;
    right: 50%;
  }
}
audio {
  width: 0;
  height: 0;
}
lar-button {
  margin: .4rem 0;
}
.radios {
  margin: 0 1rem;
}
.sipcontrols {
  min-height: 5rem;
  lar-button {
    border-radius: 50%;
    width: 3.5rem;
    height: 3.5rem;
    margin: 1.5rem auto;
    overflow: hidden;
    lar-icon {
      width: 1.5rem !important;
      height: 1.5rem !important;
    }
  
  }
}

.info {
  margin-top: .5rem;
  height: 1rem;
  text-align: center;
  color: $text-color-step-250;
}
.error {
  color: lar-color(danger, base);
  text-align: center;
}